import styled from "@emotion/styled";

export const InputTextContainer = styled.div`
  height: 5rem;
`;
